/**
 * @class InputFieldset
 * @classdesc Represents an input of type fieldset
 *
 * @extends Core.Component
 */
export default class InputFieldset extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.labelEl = el.querySelector('[data-label]');
  }

  /**
   * Gets the fieldset label
   */
  get label() {
    return this.labelEl.innerHTML;
  }

  /**
   * Sets the fieldset label with new content
   *
   * @param {HTMLElement|DOMString|string} content - The content to replace the
   *                                       current labels content with.
   */
  set label(content) {
    if (content instanceof HTMLElement) {
      this.labelEl.innerHTML = '';
      this.labelEl.appendChild(content);
    } else {
      this.labelEl.innerHTML = content;
    }
  }

  setUnavailableValues(values) {
    const existingOptions = [...this.queryAll('input-radio'), ...this.queryAll('input-swatch')];

    existingOptions.forEach(existingOption => {
      existingOption.unavailable = values.some(value => value === existingOption.value);
    });
  }

  disableValues(values) {
    const existingOptions = [...this.queryAll('input-radio'), ...this.queryAll('input-swatch')];

    existingOptions.forEach(existingOption => {
      if (values.some(value => value === existingOption.value)) {
        existingOption.disabled = true;
      }
    });
  }

  removeValues(values) {
    const existingOptions = [...this.queryAll('input-radio'), ...this.queryAll('input-swatch')];

    existingOptions.forEach(existingOption => {
      if (values.some(value => value === existingOption.value)) {
        // This doesn't feel right, maybe we should have a Component.remove(); method?
        existingOption.el.remove();
      }
    });
  }
}
